/* Mobile menu enhancement for the existing Murooj header on all three pages. */
(() => {
  if (window.MuroojMobileNav) { window.MuroojMobileNav.init(); return; }
  const instances = new Map();
  let menuId = 0;
  const icon = close => `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="${close ? 'M6 6l12 12M18 6 6 18' : 'M4 8h16M4 16h16'}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`;

  function mount(root) {
    if (instances.has(root)) return;
    const header = root.querySelector('.mf-header');
    const nav = header?.querySelector('.mf-nav');
    const order = header?.querySelector('[data-open-order]');
    const brand = header?.querySelector('.mf-brand');
    if (!nav || !order || !brand || typeof HTMLDialogElement === 'undefined') return;
    const controller = new AbortController();
    const on = (target, event, fn) => target.addEventListener(event, fn, {signal:controller.signal});
    const mobile = matchMedia('(max-width:700px)');
    const toggle = document.createElement('button');
    toggle.type = 'button'; toggle.className = 'mf-menu-toggle';
    toggle.setAttribute('aria-label', 'Open menu');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-haspopup', 'dialog');
    toggle.innerHTML = icon(false);
    const dialog = document.createElement('dialog');
    dialog.id = `mf-mobile-menu-${++menuId}`;
    dialog.className = 'mf-mobile-menu';
    dialog.setAttribute('aria-label', 'Murooj navigation');
    toggle.setAttribute('aria-controls', dialog.id);
    const top = document.createElement('div'); top.className = 'mf-mobile-menu-top';
    const logo = brand.cloneNode(true); logo.className = 'mf-mobile-menu-brand';
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'mf-menu-close';
    close.setAttribute('aria-label', 'Close menu'); close.autofocus = true;
    close.innerHTML = icon(true); top.append(logo, close);
    const links = document.createElement('nav'); links.className = 'mf-mobile-links';
    links.setAttribute('aria-label', 'Mobile navigation');
    const current = root.hasAttribute('data-catalog') || root.hasAttribute('data-product-page') ? 'Catalog' : root.hasAttribute('data-contact') ? 'Contact' : 'Home';
    nav.querySelectorAll('a').forEach(source => {
      const link = document.createElement('a');
      link.href = source.getAttribute('href');
      const label = document.createElement('span'); label.textContent = source.textContent.trim();
      const arrow = document.createElement('span'); arrow.textContent = '↗'; arrow.setAttribute('aria-hidden', 'true');
      if (label.textContent === current) link.setAttribute('aria-current', 'page');
      link.append(label, arrow); links.append(link);
    });
    const menuOrder = document.createElement('button');
    menuOrder.type = 'button'; menuOrder.className = 'mf-menu-order';
    const orderLabel = document.createElement('span'); orderLabel.textContent = 'Your order';
    const count = document.createElement('span'); count.className = 'mf-menu-order-count';
    menuOrder.append(orderLabel, count); dialog.append(top, links, menuOrder);
    header.append(toggle); root.append(dialog);
    let unlock = null;
    function lockPage() {
      const y = window.scrollY, x = window.scrollX;
      const body = document.body, html = document.documentElement;
      const previous = {position:body.style.position, top:body.style.top, left:body.style.left, width:body.style.width, overflow:html.style.overflow};
      body.style.position = 'fixed'; body.style.top = `${-y}px`; body.style.left = `${-x}px`; body.style.width = '100%'; html.style.overflow = 'hidden';
      unlock = () => {
        body.style.position = previous.position; body.style.top = previous.top; body.style.left = previous.left; body.style.width = previous.width; html.style.overflow = previous.overflow;
        window.scrollTo({top:y,left:x,behavior:'instant'}); unlock = null;
      };
    }
    function closeMenu(restoreFocus = true) {
      if (!dialog.open) return;
      unlock?.(); dialog.close();
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus && mobile.matches) toggle.focus({preventScroll:true});
    }
    function openMenu() {
      if (!mobile.matches || dialog.open) return;
      count.textContent = order.querySelector('[data-cart-count]')?.textContent || '0';
      menuOrder.setAttribute('aria-label', `Your order, ${count.textContent} items`);
      lockPage(); dialog.showModal(); toggle.setAttribute('aria-expanded', 'true');
    }
    on(toggle, 'click', () => dialog.open ? closeMenu() : openMenu());
    on(close, 'click', () => closeMenu());
    on(dialog, 'cancel', event => {event.preventDefault();closeMenu();});
    on(dialog, 'close', () => {unlock?.();toggle.setAttribute('aria-expanded','false');});
    on(dialog, 'click', event => {
      if (event.target.closest('a')) closeMenu(false);
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeMenu();
      }
    });
    on(menuOrder, 'click', () => {closeMenu();order.click();});
    on(mobile, 'change', () => {if (!mobile.matches) closeMenu(false);});
    on(window, 'pagehide', () => closeMenu(false));
    root.classList.add('mf-mobile-ready');
    instances.set(root, () => {closeMenu(false);controller.abort();toggle.remove();dialog.remove();root.classList.remove('mf-mobile-ready');instances.delete(root);});
  }
  function init() {document.querySelectorAll('[data-murooj-site]').forEach(mount);}
  window.MuroojMobileNav = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{instances.forEach((cleanup,root)=>{if(event.target.contains(root))cleanup();});});
})();
